import React from 'react';
import styles from './style.scss';
import SquareTabs from '../../atoms/SquareTabs';

const ReviewReasons = ({ reasons, selectedReasons, onChange, subTitle }) => {

    return (
        <div className={styles['review-reasons']}>
            <div className={styles['heading-txt']}>{subTitle}</div>
            <div className={styles['reason-holder']}>
                {reasons.map((cur, index) => {
                    return (
                        <SquareTabs
                            label={cur}
                            isSelected={selectedReasons.includes(cur)}
                            onClick={() => onChange(cur)}
                        />
                    )
                })

                }
            </div>
        </div>
    )

};

export default ReviewReasons;